import { render, staticRenderFns } from "./ScreenEmpacar.vue?vue&type=template&id=394326b4"
import script from "./ScreenEmpacar.vue?vue&type=script&lang=js"
export * from "./ScreenEmpacar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports